import styled from 'styled-components';
import { colors } from 'app/variables';
import { media } from 'app/utils/style';
import { colorLuminance } from 'app/utils/color';

export const Container = styled.div`
  display: block;
  flex: 0 0 auto;
  color: ${colors.pacificBlue};
  stroke: ${colors.pacificBlue};
  padding: 25px 10px;
  ${media.mediumHigh`
    padding: 0;
  `}
`;
export const Block = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  ${media.mediumHigh`
    padding: 25px 0;
  `}
`;
export const Title = styled.div`
  text-transform: uppercase;
  font-size: 16px;
  margin-bottom: 3px;
`;
export const TicketName = styled.a`
  color: ${colors.pacificBlue};
  font-size: 24px;
  text-decoration: unset;
  :hover {
    text-decoration: underline;
  }
`;
export const BackButtonContainer = styled.div`
  display: flex;
  font-size: 24px;
`;
export const BackButton = styled.a`
  position: relative;
  text-decoration: none;
  font-size: 2rem;
  font-weight: 800;
  color: ${colors.pacificBlue};

  ${({ asButton }) =>
    asButton &&
    `
  color: ${colors.white};
  font-size: 1.25rem;
  font-weight: 800;
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
  padding: 1.5rem 3.25rem;
  border-radius: 10px;
  background: ${colors.pacificBlue};

  &:hover {
    background-color: ${colorLuminance(colors.pacificBlue, -0.1)};
    border-color: ${colorLuminance(colors.pacificBlue, -0.1)};
    color: ${colors.white};
  }

  &:hover::before {
    transform: translateX(-2.5px) rotate(45deg) scale(1.05);
    transition: 0.2s linear;
  }
`}
  &::before {
    ${({ asButton }) =>
      asButton &&
      `
    border: 2px solid currentColor;
    border-right: 0;
    border-top: 0;
    content: '';
    display: block;
    height: 10px;
    margin-top: -10px;
    pointer-events: none;
    position: absolute;
    top: 57%;
    left: 1.5rem;
    transform: rotate(45deg);
    transform-origin: center;
    width: 10px;
  `}
  }
`;
